<template>

    <FloatingPanel>

        <div class="story::canvas-blocks-custom-storyHighlightSlider-BlockPanel">

            <!-- Category Accordion (only shown if categories are enabled) -->
            <accordion-input v-if="categoriesEnabled" :open="true">
                <template #label>
                    <div class="font-medium text-gray-600">Categorieën</div>
                </template>
                <template #content>
                    <div class="mb-1 text-sm text-gray-600">Selecteer categorieën om te filteren</div>

                    <select
                        v-model="options.categories"
                        multiple
                        class="w-full px-3 py-2 mt-1 transition duration-150 ease-in-out border border-gray-300 border-solid rounded-md shadow-sm focus:border-blue-300 focus:outline-none focus:shadow-outline-blue form-control form-input sm:leading-5 sm:text-sm"
                        style="min-height: 120px;"
                    >
                        <option v-for="category in categories" :key="category.id" :value="category.id">
                            {{ category.name }}
                        </option>
                    </select>
                </template>
            </accordion-input>

            <CommonInputs
                :options="options"
            />

        </div>

    </FloatingPanel>

</template>

<script>

import AbstractPanel from "@galaxy/modules/Canvas/resources/js/editor/website/editors/AbstractPanel";
import FloatingPanel from "@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/FloatingPanel";
import CommonInputs from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/CommonInputs";
import SwitchInput from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/SwitchInput";
import AccordionInput from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/helpers/Input";

export default {

    extends: AbstractPanel,

    components: {
        FloatingPanel,
        CommonInputs,
        SwitchInput,
        AccordionInput,
    },

    data() {
        return {
            categoriesEnabled: false,
            categories: [],
        };
    },

    mounted() {
        this.fetchStoryCategories();

        // Initialize options if not set
        if (!this.options.categories) {
            this.$set(this.options, 'categories', []);
        }
    },

    methods: {
        async fetchStoryCategories() {
            try {
                const response = await fetch('/api/story-categories');
                const data = await response.json();

                this.categoriesEnabled = data.enabled;
                this.categories = data.categories;
            } catch (error) {
                console.error('Failed to fetch story categories:', error);
            }
        },
    },

}

</script>
